function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.524 29l-7.214-3.67L3.096 29V10.649h14.428V29z",
  fill: "#C92128"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.93 18.875c-4.936 0-8.859-4.05-8.859-8.86 0-4.935 4.05-8.858 8.86-8.858 4.809 0 8.859 4.05 8.859 8.859.126 4.936-3.924 8.86-8.86 8.86z",
  fill: "#DBC248"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.07 16.797a7.467 7.467 0 10-6.3-13.539 7.467 7.467 0 006.3 13.54z",
  fill: "#D6C43D"
});
var _ref4 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.43,
  fill: "#B1B9CC"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.43,
  d: "M14.36 3.941l-9.24 11.77c.254.127.38.38.634.506l9.239-11.77c-.254-.253-.507-.38-.633-.506zM15.879 5.333l-8.986 11.39c.126 0 .253.127.38.127l8.859-11.264c-.127 0-.127-.126-.253-.253zM12.588 2.928l-8.86 11.138c.127.126.127.253.254.38l8.986-11.391c-.127 0-.253 0-.38-.127zM10.563 2.549l-7.72 9.745c.126.253.126.506.253.633l8.226-10.378h-.759z"
}));
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M3.096 10.016c0-4.05 3.164-7.34 7.214-7.467-4.303-.127-7.847 3.29-7.847 7.467 0 4.303 3.544 7.594 7.847 7.467-4.05-.127-7.214-3.417-7.214-7.467z",
  fill: "#C7B02E"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M10.195 19.496A9.619 9.619 0 109.661.266a9.619 9.619 0 00.534 19.23z",
  fill: "#FDB515"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M9.93 16.724a6.834 6.834 0 100-13.669 6.834 6.834 0 000 13.669z",
  fill: "#F68C1F"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M9.93 16.344a6.455 6.455 0 100-12.91 6.455 6.455 0 000 12.91z",
  fill: "#D57428"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M9.93 15.838a5.948 5.948 0 100-11.897 5.948 5.948 0 000 11.897z",
  fill: "#FEDC00"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M12.335 15.205L5.247 6.219c-.253.38-.506.633-.633 1.013l6.582 8.352 1.139-.38zM9.044 15.711L4.108 9.51v.885l4.05 5.063c.253.127.507.127.886.253zM14.486 13.686L7.272 4.574c-.126.126-.38.126-.506.253l7.34 9.239.38-.38zM15.625 11.281l-5.821-7.34c-.38 0-.633 0-1.013.126l6.455 8.227c.253-.38.38-.633.38-1.013z",
  fill: "#FCB017"
});
function SvgGold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}
export default SvgGold;